import { Observable, of } from 'rxjs';
import { share, tap } from 'rxjs/operators';
import { ReportRecord } from '../models/report.model';

export abstract class CustomDataRetriever {
  private serviceCache = {};

  abstract getCustomData(
    reportId: number,
    templateId: number,
    locale: number,
    payload: any,
    record: ReportRecord
  ): Observable<any>;

  /**
   * This method belongs to the CustomDataRetriever abstract class and it should
   * be used to cache the data incoming from the BE.
   */
  protected cachedCustomData(uri: string, request) {
    if (this.serviceCache[uri]) {
      const isObservable = typeof this.serviceCache[uri].subscribe === 'function';
      return isObservable ? this.serviceCache[uri] : of(this.serviceCache[uri]);
    }
    this.serviceCache[uri] = request().pipe(
      tap(response => (this.serviceCache[uri] = response)),
      share()
    );
    return this.serviceCache[uri];
  }
}
